import { colors } from "../pallette/colors";

export const DATE_FORMAT = 'yyyy.MM.dd';

export const formatDate = (dateString:any) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDateTime = (dateString:any) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours());
  const mins = String(date.getMinutes());
  return `${year}-${month}-${day} ${hour}:${mins}`;
};

export const formatHHmmToDateTime = (timeString:any) => {
  const [hours, minutes] = timeString.split(':'); // Split the time into hours and minutes
  
  const today = new Date(); // Get today's date
  today.setHours(hours); // Set the hours
  today.setMinutes(minutes); // Set the minutes
  today.setSeconds(0); // Optional: set seconds to 0 if needed
  
  return formatDateTime(today);
}

export const formatDateTimeToHHmm = (dateTime:any) => {  
  const today = new Date(dateTime); // Get today's date
  const hours = today.getHours().toString().padStart(2, '0');
  const minutes = today.getMinutes().toString().padStart(2, '0');
  
  return `${hours}:${minutes}`;
}

export const formatDateTimeTomm = (dateTime:any) => {  
  const today = new Date(dateTime); 
  const minutes = today.getMinutes();
  
  return `${minutes}`;
}

export const formatMMToDateTime = (mmString:any) => {
  const today = new Date();
  today.setMinutes(mmString); // Set the minutes
  today.setSeconds(0); // Optional: set seconds to 0 if needed
  
  return formatDateTime(today);
  
}
export const formatToYear = (dateString:any) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  return `${year}`;
};

export function formatMonthYear(date:any) {
  const d = new Date(date);
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  
  const month = months[d.getMonth()];
  const year = d.getFullYear();
  
  return `${month} ${year}`;
}

export const genUID: any = (str:any) => {
  if(str == undefined) {
    return '';
  }
  return str.slice(1);
};


  // Helper function to convert time string (HH:MM) to minutes from midnight
export const timeToMinutes = (time: string) => {
    if (time == undefined || time == '0') {
        return 0;
    }
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
};

export const detectConflicts = (filteredData: any[]) => {
  const conflictIndices: number[] = [];

  for (let i = 0; i < filteredData.length; i++) {
      const currentRecord = filteredData[i];
      const currentStartTime = timeToMinutes(currentRecord?.startTimeStr ? currentRecord?.startTimeStr : 0);
      const currentEndTime = currentStartTime + parseInt(currentRecord.duration);

      // Compare with every record that comes after the current record
      for (let j = i + 1; j < filteredData.length; j++) {
          const nextRecord = filteredData[j];
          const nextStartTime = timeToMinutes(nextRecord?.startTimeStr ? nextRecord?.startTimeStr : 0);
          const nextEndTime = nextStartTime + parseInt(nextRecord.duration);

          // Detect conflict (if the next record starts before the current one ends, or overlaps)
          if (nextStartTime != 0 && currentEndTime != 0 && currentStartTime != 0 && nextEndTime != 0 && 
            nextStartTime <= currentEndTime && currentStartTime <= nextEndTime) {
              conflictIndices.push(i); // Current record in conflict
              conflictIndices.push(j); // Next record in conflict
          }
      }
  }
  return conflictIndices;
};

//status colors and labels
export const commonStatus = [
  {statusName: 'Not Evaluated', color: colors.statusColors.notEvaluated},
  {statusName: 'Not Met', color: colors.statusColors.notMet},
  {statusName: 'Partial', color: colors.statusColors.partial},
  {statusName: 'Met', color: colors.statusColors.met}
];

export const phaseStatus = [
  {statusName: 'Not Started', color: colors.statusColors.notEvaluated},
  {statusName: 'Current', color: colors.yellow.bright},
  {statusName: 'Completed', color: colors.statusColors.met}
];

export const interimReportStatus = [
  {statusName: 'Not Met', color: colors.statusColors.notMet},
  {statusName: 'Partial', color: colors.statusColors.partial},
  {statusName: 'Met', color: colors.statusColors.met}
];

export const finalReportStatus = [
  {statusName: 'Not Started', color: '#FFF'},
  {statusName: 'Not Met', color: colors.statusColors.notMet},
  {statusName: 'Partial', color: colors.statusColors.partial},
  {statusName: 'Met', color: colors.statusColors.met}
];

export const rabgStatus = [
  {statusName: 'MISSED', color: colors.lightishRed},
  {statusName: 'AT_RISK', color: colors.tangerine},
  {statusName: 'ON_TRACK', color: colors.vibrantGreen},
  {statusName: 'COMPLETE', color: colors.gold},
  {statusName: 'NOT_STARTED', color: colors.middleGrey}
];

export const siteReviewStatus = [
  {statusName: 'NOT_EVALUATED', color: colors.notEvalGrey},
  {statusName: 'NOT_MET', color: colors.lightishRed},
  {statusName: 'PARTIAL', color: colors.tangerine},
  {statusName: 'MET', color: colors.shamrockGreen},
];

export const liecenceHome = [
  {statusName: 'NOT_MET', color: colors.lightishRed},
  {statusName: 'PARTIAL', color: colors.tangerine},
  {statusName: 'MET', color: colors.vibrantGreen},
  {statusName: '_', color: colors.gold},
  {statusName: 'NOT_EVALUATED', color: colors.middleGrey},
];

export const liecenceAdmin = [
  {statusName: 'DRAFT', color: colors.middleGrey},
  {statusName: 'ISSUED', color: colors.vibrantGreen},
];

export const privacyStatus = [
  {statusName: 'DC_FS_PUBLIC', color: colors.vibrantGreen},
  {statusName: 'PRIVATE', color: colors.tangerine},
];

export const frequencyStatus = [
  {statusName: 'WEEKLY', dbIndex: 1},
  {statusName: 'FORTHNIGHTLY', dbIndex: 2},
  {statusName: 'MONTHLY', dbIndex: 3},
  {statusName: 'QUARTERLY', dbIndex: 4},
  {statusName: 'SEMIANNUALLY', dbIndex: 5},
  {statusName: 'ANNUALLY', dbIndex: 6},
]

export const calcTaskPercentage = (taskData:any) => {
  if (taskData.length === 0) return 0;

  const completedCount = taskData.filter((task:any) => task.checked).length;
  const percentage = (completedCount / taskData.length) * 100;
  const finalPercentage:any = percentage.toFixed(2);
  return finalPercentage;
}

//Project Status Calculation
export const PerformancePlanStatus = {
  Missed: 0,
  AtRisk: 1,
  OnTrack: 2,
  Complete: 3,
  NotStarted: 4
};
export const getAverageProjectStatus = (statusList:any) => {
  let result = PerformancePlanStatus.NotStarted;

  if (!statusList.length) {
    return result;
  }

  if (statusList.every((status:any) => 
      status === PerformancePlanStatus.NotStarted || 
      status === PerformancePlanStatus.Complete)) {
    result = PerformancePlanStatus.OnTrack;
  }

  if (statusList.every((status:any) => status === PerformancePlanStatus.NotStarted)) {
    result = PerformancePlanStatus.NotStarted;
  }

  if (statusList.every((status:any) => status === PerformancePlanStatus.Complete)) {
    result = PerformancePlanStatus.Complete;
  }

  if (statusList.some((status:any) => 
      status !== PerformancePlanStatus.NotStarted && 
      status !== PerformancePlanStatus.Complete)) {
    
    const openStatusList = statusList.filter((status:any) => 
      status !== PerformancePlanStatus.NotStarted && 
      status !== PerformancePlanStatus.Complete);

    result = Math.floor(
      openStatusList.reduce((sum:any, status:any) => sum + status, 0) /
      Math.max(openStatusList.length, 1)
    );
  }

  return result;
}

//sitereview Status Calculation
export const siteReviewStatusIndex = {
  NotEvaluated: 0,
  NotMet: 1,
  Partial: 2,
  Met: 3,
};
export const getAverageSiteStatus = (statusList:any) => {
  let result = siteReviewStatusIndex.NotEvaluated;

  if (!statusList.length) {
    return result;
  }

  if (statusList.every((status:any) => 
      status === siteReviewStatusIndex.NotEvaluated || 
      status === siteReviewStatusIndex.Met)) {
    result = siteReviewStatusIndex.Partial;
  }

  if (statusList.every((status:any) => status === siteReviewStatusIndex.NotEvaluated)) {
    result = siteReviewStatusIndex.NotEvaluated;
  }

  if (statusList.every((status:any) => status === siteReviewStatusIndex.Met)) {
    result = siteReviewStatusIndex.Met;
  }

  if (statusList.some((status:any) => status === siteReviewStatusIndex.NotMet)) {
    result = siteReviewStatusIndex.NotMet;
  } 

  if (statusList.some((status:any) => 
      status !== siteReviewStatusIndex.NotEvaluated && 
      status !== siteReviewStatusIndex.Met)) {
    
    const openStatusList = statusList.filter((status:any) => 
      status !== siteReviewStatusIndex.NotEvaluated && 
      status !== siteReviewStatusIndex.Met);

    result = Math.floor(
      openStatusList.reduce((sum:any, status:any) => sum + status, 0) /
      Math.max(openStatusList.length, 1)
    );
  }

  return result;
}

export const calculateGoalProgress = (statuses:any) => {
  const percentCoefficient = 100;
  const completedCount = (statuses?.filter((d:any) => d === PerformancePlanStatus.Complete))?.length;
  const totalCount = statuses?.length;
  const progress = percentCoefficient * completedCount / totalCount;
  return progress;
}

export const capitalizeKeys:any = (obj:any) => {
  if (Array.isArray(obj)) {
      return obj.map(item => capitalizeKeys(item));
  } else if (obj !== null && typeof obj === 'object') {
      return Object.fromEntries(
          Object.entries(obj).map(([key, value]) => {
              var capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
              if (capitalizedKey == 'StandardHistory') capitalizedKey = 'Standards';
              if (capitalizedKey == 'Ragb') capitalizedKey = 'Status';
              return [capitalizedKey, capitalizeKeys(value)];
          })
      );
  }
  return obj;
}
export const isEmpty = (value: any) => {
  return value === null || value === undefined || value === '' || Number.isNaN(value) || (Array.isArray(value) && value.length === 0);
}

//screen resolution
export const screenResolution = {
  mobile: 768,
  laptop13inch: 1440,
  standardRablet: 1279,
}

//regex
export const evaluationCriteriaRegex = /evaluation\/criteria+$/;
export const evaluationCriterionRegex = /evaluation\/criteria\/\d+$/;
export const evaluationStandardsRegex = /evaluation\/criteria\/\d+\/standards$/;
export const evaluationSelectedStandardsRegex = /evaluation\/criteria\/\d+\/standards\/\d+$/;
export const evaluationSelectedStandardsReportRegex = /evaluation\/criteria\/\d+\/standards\/\d+\/evaluationreports$/;
export const evaluationSelectedStandardsActionsRegex = /evaluation\/criteria\/\d+\/standards\/\d+\/actions\/\d+$/;
export const evaluationCriteriaActionsRegex = /evaluation\/criteria\/\d+\/actions+$/;
export const evaluationSelectedCriteriaActionsRegex = /evaluation\/criteria\/\d+\/actions\/\d+$/;
export const evaluationCriteriaEvidencesRegex = /evaluation\/criteria\/\d+\/evidences+$/;
export const licenceCriteriaRegex = /licence\/criteria+$/;
export const licenceCriterionRegex = /licence\/criteria\/\d+$/;
export const licenceStandardsRegex = /licence\/criteria\/\d+\/standards$/;
export const licenceSelectedStandardsRegex = /licence\/criteria\/\d+\/standards\/\d+$/;
export const licenceSelectedStandardsActionsRegex = /licence\/criteria\/\d+\/standards\/\d+\/actions\/\d+$/;
export const licenceCriteriaActionsRegex = /licence\/criteria\/\d+\/actions+$/;
export const licenceSelectedCriteriaActionsRegex = /licence\/criteria\/\d+\/actions\/\d+$/;
export const licenceCriteriaEvidencesRegex = /licence\/criteria\/\d+\/evidences+$/;
export const onsiteSessionsRegex = /onsite\/sessions+$/;
export const onsiteSelectedSessionRegex = /onsite\/sessions\/\d+$/;
export const onsiteSessionCriteriaRegex = /onsite\/sessions\/\d+\/criteria$/;
export const onsiteSelectedCriteriaRegex = /onsite\/sessions\/\d+\/criteria\/\d+$/;
export const onsiteSessionStandardsRegex = /onsite\/sessions\/\d+\/criteria\/\d+\/standards+$/;
export const onsiteSelectedStandardRegex = /onsite\/sessions\/\d+\/criteria\/\d+\/standards\/\d+$/;
export const projectsRegex = /performanceplan\/projects+$/;
export const selectedProjectRegex = /performanceplan\/projects\/\d+$/;
export const selectedProjectActionRegex = /performanceplan\/projects\/\d+\/actions\/\d+$/;
export const actionsRegex = /performanceplan\/actions+$/;
export const selectedActionRegex = /performanceplan\/actions\/\d+$/;
export const dashboardEvaluationRegex = /dashboard\/evaluation\/+$/;
export const dashboardLicenceRegex = /dashboard\/licence\/+$/;
export const dashboardPeopleRegex = /dashboard\/people\/+$/;
export const dashboardDatesRegex = /dashboard\/dates\/+$/;
export const dashboardProgressRegex = /dashboard\/progress\/+$/;
export const dashboardFinanceRegex = /licenceanalytics\/finance\/dashboard+$/;
export const exploreFinanceRegex = /licenceanalytics\/finance\/explore+$/;
export const dashboardStaffRegex = /licenceanalytics\/staff\/dashboard+$/;
export const exploreStaffRegex = /licenceanalytics\/staff\/explore+$/;
export const dashboardFacilitiesRegex = /licenceanalytics\/facilities\/dashboard+$/;
export const exploreFacilitiesRegex = /licenceanalytics\/facilities\/explore+$/;
export const dashboardTeamsRegex = /licenceanalytics\/teams\/dashboard+$/;
export const exploreTeamsRegex = /licenceanalytics\/teams\/explore+$/;
export const dashboardPlayersRegex = /licenceanalytics\/players\/dashboard+$/;
export const explorePlayersRegex = /licenceanalytics\/players\/explore+$/;
export const goalsRegex = /goals\/+$/;
export const selectedGoalRegex = /goals\/\d+$/;
export const selectedSubGoalRegex = /goals\/\d+\/subgoal\/\d+$/;
export const goalProjectDetailsRegex = /goals\/\d+\/project\/\d+$/;
export const subGoalProjectDetailsRegex = /goals\/\d+\/subgoal\/\d+\/project\/\d+$/;